/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageTargetTimeSeriesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageTargetTimeSeriesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageTargetTimeSeriesSecurity = {
  option1?: GetToolUsageTargetTimeSeriesSecurityOption1 | undefined;
  option2?: GetToolUsageTargetTimeSeriesSecurityOption2 | undefined;
};

export type GetToolUsageTargetTimeSeriesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageTargetTimeSeriesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageTargetTimeSeriesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetToolUsageTargetTimeSeriesSecurityOption1$Outbound,
    GetToolUsageTargetTimeSeriesSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getToolUsageTargetTimeSeriesSecurityOption1ToJSON(
  getToolUsageTargetTimeSeriesSecurityOption1:
    GetToolUsageTargetTimeSeriesSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageTargetTimeSeriesSecurityOption1$outboundSchema.parse(
      getToolUsageTargetTimeSeriesSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetTimeSeriesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageTargetTimeSeriesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetToolUsageTargetTimeSeriesSecurityOption2$Outbound,
    GetToolUsageTargetTimeSeriesSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getToolUsageTargetTimeSeriesSecurityOption2ToJSON(
  getToolUsageTargetTimeSeriesSecurityOption2:
    GetToolUsageTargetTimeSeriesSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageTargetTimeSeriesSecurityOption2$outboundSchema.parse(
      getToolUsageTargetTimeSeriesSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetTimeSeriesSecurity$Outbound = {
  Option1?: GetToolUsageTargetTimeSeriesSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageTargetTimeSeriesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageTargetTimeSeriesSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageTargetTimeSeriesSecurity$Outbound,
  GetToolUsageTargetTimeSeriesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageTargetTimeSeriesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageTargetTimeSeriesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageTargetTimeSeriesSecurityToJSON(
  getToolUsageTargetTimeSeriesSecurity: GetToolUsageTargetTimeSeriesSecurity,
): string {
  return JSON.stringify(
    GetToolUsageTargetTimeSeriesSecurity$outboundSchema.parse(
      getToolUsageTargetTimeSeriesSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageTargetTimeSeriesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageTargetTimeSeriesRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageTargetTimeSeriesRequest$Outbound,
  GetToolUsageTargetTimeSeriesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageTargetTimeSeriesRequestToJSON(
  getToolUsageTargetTimeSeriesRequest: GetToolUsageTargetTimeSeriesRequest,
): string {
  return JSON.stringify(
    GetToolUsageTargetTimeSeriesRequest$outboundSchema.parse(
      getToolUsageTargetTimeSeriesRequest,
    ),
  );
}
